module.exports = __webpack_public_path__ + "static/media/fill_pattern.fragment.9e741a31.glsl";